import { createAction, props } from '@ngrx/store';
import {
  AccountCheck,
  Country,
  IBillingSettings,
  IUserAccess,
  Language,
  Meeting,
  Subject,
  SubjectsRegistry,
} from 'lingo2-models';

export const clearData = createAction('[Data] Clear');

export const loadAccountCheck = createAction('[Data] Load account check');
export const forceLoadAccountCheck = createAction('[Data] Force load account check');
export const loadAccountCheckSuccess = createAction(
  '[Data] Load account check success',
  props<{
    accountCheckData: Partial<AccountCheck>;
  }>(),
);

export const loadCountries = createAction(
  '[Data] Load countries',
  props<{
    locale: string;
  }>(),
);
export const forceLoadCountries = createAction(
  '[Data] Force load countries',
  props<{
    locale: string;
  }>(),
);
export const loadCountriesSuccess = createAction(
  '[Data] Load countries success',
  props<{
    countries: Country[];
  }>(),
);

export const loadAllLanguages = createAction(
  '[Data] Load all languages',
  props<{
    locale: string;
  }>(),
);
export const loadFilteredLanguages = createAction(
  '[Data] Load filtered languages',
  props<{
    locale: string;
  }>(),
);
export const forceLoadLanguages = createAction(
  '[Data] Force load countries',
  props<{
    locale: string;
    all: boolean;
  }>(),
);
export const loadAllLanguagesSuccess = createAction(
  '[Data] Load all languages success',
  props<{
    languages: Language[];
  }>(),
);
export const loadFilteredLanguagesSuccess = createAction(
  '[Data] Load filtered languages success',
  props<{
    languages: Language[];
  }>(),
);

export const loadMyNearestMeeting = createAction('[Data] Load my nearest meeting');
export const forceLoadMyNearestMeeting = createAction('[Data] Force load my nearest meeting');

export const loadProfileSettings = createAction('[Data] Load profile settings');
export const loadProfileSettingSuccess = createAction(
  '[Data] Load profile settings success',
  props<{
    settings: IUserAccess;
  }>(),
);

export const loadBillingSetting = createAction(
  '[Data] Load billing settings',
  props<{
    force?: boolean;
  }>(),
);
export const loadBillingSettingSuccess = createAction(
  '[Data] Load billing settings success',
  props<{
    settings: IBillingSettings;
  }>(),
);

export const loadSubjects = createAction(
  '[Data] Load subjects',
  props<{
    locale?: string;
    force?: boolean;
  }>(),
);
export const loadSubjectSuccess = createAction(
  '[Data] Load subjects success',
  props<{
    subjects: Subject[];
  }>(),
);

export const loadSubjectsV2 = createAction(
  '[Data] Load subjects V2',
  props<{
    locale?: string;
    force?: boolean;
  }>(),
);
export const loadSubjectsV2Success = createAction(
  '[Data] Load subjects V2 success',
  props<{
    subjectsV2: SubjectsRegistry;
  }>(),
);
